interface translations{

}

class LanguagePack {
    private translations = [
        {
            name: 'homeTitle',
            data: {
                en: 'home',
                fr: 'accueil',
                de: ''
            }
        },
        {
            name: 'donateTitle',
            data: {
                en: 'Make a donation',
                fr: 'Faire un don',
                de: ''
            }
        },
        {
            name: 'creditTitle',
            data: {
                en: 'Credit account',
                fr: 'Créditer le compte',
                de: ''
            }
        },
        {
            name: 'aboutTitle',
            data: {
                en: 'About SwissDonations',
                fr: 'A propos de SwissDonations',
                de: ''
            }
        },
        {
            name: 'documentsTitle',
            data: {
                en: 'My donation documents',
                fr: 'Mes documents de donations',
                de: ''
            }
        },
        {
            name: 'securityTitle',
            data: {
                en: '',
                fr: '',
                de: ''
            }
        },
        {
            name: 'userTitle',
            data: {
                en: 'User profile',
                fr: 'Profile utilisateur',
                de: ''
            }
        },
        {
            name: 'calendarDoneText',
            data: {
                en: 'done',
                fr: 'terminé',
                de: ''
            }
        },
        {
            name: 'calendarClearText',
            data: {
                en: 'Clear',
                fr: 'Effacer',
                de: ''
            }
        },
        {
            name: 'calendarCancelText',
            data: {
                en: 'Cancel',
                fr: 'Annuler',
                de: ''
            }
        },

    ]

    public getHomeTranslations(lan:string) {
        let translations:any={};
        this.translations.forEach((element: any) => {
            let name= element.name;
            let string = element.data[lan]
            translations[name]=string;
        });

        return translations;
    }

}


export default LanguagePack;